export const translations = {
  en: {
    translation: {
      Search: 'Search',
      'Drag and drop': 'Drag and drop',
      'an image here': 'an image here',
      'Manufacturer Number': 'Manufacturer No.',
      'Mfr. No.': 'Mfr. No.',
      'Close group': 'Close group',
      'Show group': 'Show group',
      'Adjust the search frame around your object for improved results':
        'Adjust the search frame around your object for improved results',
      'Crop the image for better results': 'Crop the image for better results',
      'Items per page': 'Items per page',
      'Search with an image': 'Search with an image',
      'Clear text search': 'Clear text search',
      'View details': 'View details',
      'Clear image search': 'Clear image search ',
      'Add or change pre-filter': 'Add or change pre-filter',
      'Expand all': 'Expand all',
      'Collapse all': 'Collapse all',
      Brand: 'Brand',
      'Product name': 'Product name',
      loading: 'loading',
      'No products were found matching your search criteria.':
        'No products were found matching your search criteria.',
      'Please upload an image or enter a keyword to search.':
        'Please upload an image or enter a keyword to search.',
      'No matches found': 'No matches found',
      'No matches found for your request': 'No matches found for your request',
      'Clear all': 'Clear all',
      Cancel: 'Cancel',
      Apply: 'Apply',
      'Back to request image': 'Back to request image',
      'Please select a search criteria before search request to refine and yield accurate results.':
        'Please select a search criteria before search request to refine and yield accurate results.',
      'Search criteria is not selected': 'Search criteria is not selected',
      Inquiry: 'Inquiry',
      'Call us': 'Call us',
      'Submit your inquiry': 'Submit your inquiry',
      'Submit your image for inquiry': 'Submit your image for inquiry',
      'Your email (required)': 'Your email (required)',
      'Please enter a valid email.': 'Please enter a valid email.',
      'Additional information': 'Additional information',
      Send: 'Send',
      'Experience Visual Search': 'Experience Visual Search',
      'Start your visual search by selecting an image below.':
        'Start your visual search by selecting an image below.',
      'Are these results useful?': 'Are these results useful?',
      'Thank you for your feedback': 'Thank you for your feedback',
      'Select a Filter': 'Select a Filter',
      'Get personalised help from our team of product experts.':
        'Get personalised help from our team of product experts.',
      'Adjust the selection frame for better results':
        'Adjust the selection frame for better results',
      'Replace Current Data?': 'Replace Current Data?',
      'Uploading a new image will overwrite your current search parameters, text, and results. Are you sure you want to proceed?':
        'Uploading a new image will overwrite your current search parameters, text, and results. Are you sure you want to proceed?',
      "Don't show this again": "Don't show this again",
      Continue: 'Continue',
      'Request sent successfully': 'Request sent successfully',
      'No result found': 'No result found',
      'Load More': 'Load More',
      'No filters found': 'No filters found',
      'Please enable location services when prompted.':
        'Please enable location services when prompted.',
      'I understand': 'I understand',
      'We have successfully defined the search criteria': 'Nameplate detected and matched to {{prefilter_value}}. Items are shown for this {{preFilterTitle}}. You can now upload an image or enter a keyword to search.',
      'Type plates': 'Type plates',
      'Parts': 'Parts',
      'Labels': 'Labels',
      'Barcodes': 'Barcodes',
      'Nameplate not matching': 'Nameplate detected, but {{prefilter_value}} was not found in the list. You can select the correct {{preFilterTitle}} to continue.',
      'Extracted details from the nameplate could not be matched': 'The extracted details could not be matched to a known {{preFilterTitle}}. Please select a different {{preFilterTitle}} and continue searching.',
      'Showing results for machine': `Showing results for {{prefilter_title}} '{{prefilter_value}}'`,
      'No matches found for': `No matches found for {{prefilter_title}} '{{prefilter_value}}'. Showing all items instead.`,
    },
  },
  de: {
    translation: {
      Search: 'Suche',
      'Drag and drop': 'Bild hierher ziehen',
      'an image here': '',
      'Mfr. No.': 'Herst. Teile-Nr.',
      'Manufacturer Number': 'Herstellerteilenummer',
      'Close group': 'Schließe Gruppe',
      'Show group': 'Zeige Gruppe',
      'Adjust the search frame around your object for improved results':
        'Anpassen des Rahmens für bessere Ergebnisse',
      'Crop the image for better results': 'Zuschneiden für bessere Ergebnisse',
      'Items per page': 'Artikel pro Seite',
      'Search with an image': 'Bildsuche',
      'Clear text search': 'Suchtext löschen',
      'View details': 'Anzeige der Details',
      'Clear image search': 'Bildsuche zurück setzen',
      'Add or change pre-filter': 'Vorfilter hinzufügen oder ändern',
      'Expand all': 'Alles anzeigen',
      'Collapse all': 'Alle ausblenden',
      Brand: 'Marke',
      'Product name': 'Produktname',
      loading: 'Lädt',
      'No products were found matching your search criteria.':
        'Keine Produkte entsprechen Ihren Suchkriterien.',
      'Please upload an image or enter a keyword to search.':
        'Für die Suche bitte Bild hochladen oder Stichwort eingeben.',
      'No matches found for your request':
        'Keine Treffer für Ihre Anfrage gefunden',
      'Clear all': 'Alles löschen',
      Cancel: 'Abbrechen',
      Apply: 'Anwenden',
      'Back to request image': 'Zurück zur Bildanfrage',
      'Please select a search criteria before search request to refine and yield accurate results.':
        'Bitte wählen Sie vor der Suchanfrage ein Suchkriterium aus, um die Suche zu verfeinern und genaue Ergebnisse zu erhalten.',
      'Search criteria is not selected': 'Suchkriterien sind nicht ausgewählt',
      Inquiry: 'Anfrage',
      'Call us': 'Rufen Sie uns an',
      'Submit your inquiry': 'Senden Sie Ihre Anfrage',
      'Submit your image for inquiry': 'Senden Sie Ihr Bild für eine Anfrage',
      'Your email (required)': 'Ihre E-Mail (erforderlich)',
      'Please enter a valid email.':
        'Bitte geben Sie eine gültige E-Mailadresse an',
      'Additional information': 'Zusätzliche Informationen',
      Send: 'Senden',
      'Experience Visual Search': 'Erleben Sie die visuelle Suche',
      'Start your visual search by selecting an image below.':
        'Beginnen Sie Ihre visuelle Suche und wählen eines der  Bilder aus.',
      'Are these results useful?': 'Sind diese Ergebnisse nützlich?',
      'Thank you for your feedback': 'Vielen Dank für Ihr Feedback',
      'Select a Filter': 'Filter wählen',
      'Get personalised help from our team of product experts.':
        'Holen Sie sich persönliche Hilfe von unserem Team von Produktexperten.',
      'No matches found': 'Keine Treffer gefunden',
      'Adjust the selection frame for better results':
        'Anpassen des Rahmens für bessere Ergebnisse',
      'Replace Current Data?': 'Aktuelle Daten ersetzen?',
      'Uploading a new image will overwrite your current search parameters, text, and results. Are you sure you want to proceed?':
        'Durch das Hochladen eines neuen Bildes werden Ihre aktuellen Suchparameter, Texte und Ergebnisse überschrieben. Möchten Sie wirklich fortfahren?',
      "Don't show this again": 'Nicht mehr anzeigen',
      Continue: 'Fortfahren',
      'Request sent successfully': 'Anfrage erfolgreich gesendet',
      'No result found': 'Keine Ergebnisse',
      'Load More': 'Mehr laden',
      'No filters found': 'Kein Filter gefunden',
      'Please enable location services when prompted.':
        'Bitte erlauben Sie den Zugriff auf Ihren Standort.',
      'I understand': 'Weiter',
      'We have successfully defined the search criteria': 'Typenschild erkannt und mit {{prefilter_value}} abgeglichen. Es werden Artikel für dieses {{preFilterTitle}}. Sie können nun ein Bild hochladen oder ein Stichwort zur Suche eingeben.',
      'Type plates': 'Typenschilder',
      'Parts': 'Teile',
      'Labels': 'Etiketten',
      'Barcodes': 'Barcodes',
      'Nameplate not matching': 'Typenschild erkannt, aber {{prefilter_value}} wurde nicht in der Liste gefunden. Sie können die richtigen {{preFilterTitle}}, um fortzufahren.',
      'Extracted details from the nameplate could not be matched': 'Die extrahierten Details konnten keinem bekannten {{preFilterTitle}} zugeordnet werden. Bitte wählen Sie einen anderen {{preFilterTitle}} aus und setzen Sie die Suche fort.',
      'Showing results for machine': `Ergebnisse für {{prefilter_title}} '{{prefilter_value}}' anzeigen`,
      'No matches found for': `Keine Übereinstimmungen gefunden für {{prefilter_title}} '{{prefilter_value}}'. Alle Artikel anzeigen stattdessen.`,
    },
  },
  pt: {
    translation: {
      Search: 'Busca',
      'Drag and drop': 'Escolha uma imagem',
      'an image here': '',
      'Manufacturer Number': 'Número do fabricante',
      'Mfr. No.': 'Nr. do Fab',
      'Close group': 'Fechar grupo',
      'Show group': 'Mostrar grupo',
      'Adjust the search frame around your object for improved results':
        'Ajuste a caixa de busca para melhores resultados',
      'Crop the image for better results':
        'Ajuste o campo de imagem para melhores resultados',
      'Items per page': 'Itens por página',
      'Search with an image': 'Busque com uma imagem',
      'Clear text search': 'Limpar busca',
      'View details': 'Ver detalhes',
      'Clear image search': 'Limpar imagem',
      'Add or change pre-filter': 'Adicionar ou selecionar pre-filtro',
      'Expand all': 'Expandir',
      'Collapse all': 'esconder tudo',
      Brand: 'Marca',
      loading: 'Carregando',
      'No products were found matching your search criteria.':
        'Nenhum produto foi encontrado com estes critérios.',
      'Please upload an image or enter a keyword to search.':
        'Faça o upload de uma imagem ou busque via texto',
      'No matches found':
        'Não foram encontrados resultados para sua solicitação',
      'No matches found for your request':
        'Não foram encontrados resultados para sua solicitação',
      'Clear all': 'Limpar tudo',
      Cancel: 'Cancelar',
      Apply: 'Aplicar',
      'Back to request image': 'Retroceder para imagem inicial',
      'Please select a search criteria before search request to refine and yield accurate results.':
        'Selecione um critérios de pesquisa antes da solicitação de pesquisa para refinar e produzir resultados precisos.',
      'Search criteria is not selected':
        'Os critérios de pesquisa não estão selecionados',
      Inquiry: 'Inquérito',
      'Call us': 'Contactar-nos',
      'Submit your inquiry': 'Enviar o seu pedido',
      'Submit your image for inquiry': 'Envie sua imagem para consulta',
      'Your email (required)': 'Seu e-mail (obrigatório)',
      'Please enter a valid email.': 'Introduza um e-mail válido.',
      'Additional information': 'Informações adicionais',
      Send: 'Enviar',
      'Experience Visual Search': 'Experimente a pesquisa visual',
      'Start your visual search by selecting an image below.':
        'Comece sua busca visual selecionando uma imagem abaixo.',
      'Thank you for your feedback': 'Obrigado pelo seu feedback',
      'Select a Filter': 'Selecione um filtro',
      'Get personalised help from our team of product experts.':
        'Obtenha ajuda personalizada de nossa equipe de especialistas em produtos.',
      'Adjust the selection frame for better results':
        'Ajuste a caixa de busca para melhores resultados',
      'Replace Current Data?': 'Substituir os dados atuais?',
      'Uploading a new image will overwrite your current search parameters, text, and results. Are you sure you want to proceed?':
        'Carregar uma nova imagem substituirá seus parâmetros de pesquisa, texto e resultados atuais. Tem certeza de que deseja prosseguir?',
      "Don't show this again": 'Não mostrar isso novamente',
      Continue: 'Continuar',
      'Request sent successfully': 'Solicitação enviada com sucesso',
      'Are these results useful?': 'Esses resultados são úteis?',
      'No result found': 'Nenhum resultado',
      'Load More': 'Carregar mais',
      'No filters found': 'Nenhum filtro encontrado',
      'Please enable location services when prompted.':
        'Por favor, ative os serviços de localização quando solicitado',
      'I understand': 'Compreendo',
      'We have successfully defined the search criteria': 'Placa de identificação detetada e correspondente a {{prefilter_value}}. São apresentados os itens para esta {{preFilterTitle}}. Agora pode carregar uma imagem ou introduzir uma palavra-chave para pesquisar.',
      'Type plates': 'Placa de identificação',
      'Parts': 'Peças',
      'Labels': 'Etiquetas',
      'Barcodes': 'Códigos de barras',
      'Nameplate not matching': 'Placa de identificação detetada, mas {{prefilter_value}} não foi encontrado na lista. Pode selecionar os {{preFilterTitle}} corretos para continuar.', 
      'Extracted details from the nameplate could not be matched': 'Os detalhes extraídos não puderam ser correspondidos a um {{preFilterTitle}} conhecido. Selecione um {{preFilterTitle}} diferente e continue a pesquisa.',
      'Showing results for machine': `Mostrando resultados para {{prefilter_title}} '{{prefilter_value}}'`,
      'No matches found for': `Não foram encontrados resultados para {{prefilter_title}} '{{prefilter_value}}'. Mostrando todos os itens em vez disso.`,
    },
  },
};
